import React, { useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/adventure_time.css';
import { getParsedRevision } from '../../lib/demoEdgeRevisionUtils';
import './_styles.scss';

import { Dialog, CloseDialogAction } from '../../../../../common/components/Dialog/Dialog';
import DemoEdgeComponentsList from '../../components/DemoEdgeControllerComponentsList/DemoEdgeControllerComponentsList';
import InfoItem from '../../../../../common/components/InfoItem/InfoItem';

const renderComponentsView = (revisionData) => (
  <div className="task-definition-section parsed-view">
    <h3>Components</h3>
    <DemoEdgeComponentsList revision={revisionData} />
  </div>
);

const renderJsonView = (revisionJson) => {
  if (!revisionJson) return null;

  return (
    <div className="task-definition-section json-view">
      <h3>Full Revision JSON</h3>
      <div className="json-definition">
        <JSONPretty id="json-pretty" data={revisionJson} />
      </div>
    </div>
  );
};

const renderTaskInfo = (task) => (
  <div className="task-info-section">
    <h3>Task Information</h3>
    <div className="info-grid">
      <InfoItem label="Task ID" value={<span className="task-id">{task.taskId}</span>} />
      <InfoItem label="Name" value={task.name} />
      <InfoItem label="Type" value={task.type} />
      <InfoItem label="Status" value={task.status} />
      <InfoItem label="Execution Status" value={task.executionStatus} />
      <InfoItem
        label="Created At"
        value={new Date(task.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
      />
      <InfoItem
        label="Last Reported"
        value={new Date(task.lastReported).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
      />
    </div>
  </div>
);

const DemoEdgeTaskDetailsDialog = ({ open, onClose, task = null, revision = null, hideTaskInfo = false }) => {
  const [viewMode, setViewMode] = useState('parsed');

  if (!task && !revision) return null;

  const revisionData = revision || null;
  const parsedRevision = getParsedRevision(revisionData);
  const jsonContent = JSON.stringify(parsedRevision, null, 2);
  const dialogTitle = task ? `Task Definition — ${task.taskId}` : 'Firmware Configuration Details';

  return (
    <Dialog open={open} onClose={onClose} title={dialogTitle} maxWidth="md" fullWidth actions={<CloseDialogAction onClose={onClose} />} className="task-details-dialog">
      <div className="task-definition-content">
        <div className="view-mode-tabs">
          <Tabs value={viewMode} onChange={(e, newValue) => setViewMode(newValue)} variant="standard">
            <Tab label="Parsed" value="parsed" />
            <Tab label="JSON" value="json" />
          </Tabs>
        </div>

        {viewMode === 'parsed' && <>{renderComponentsView(revisionData)}</>}

        {viewMode === 'json' && renderJsonView(jsonContent)}

        {!hideTaskInfo && task && renderTaskInfo(task)}
      </div>
    </Dialog>
  );
};

export default DemoEdgeTaskDetailsDialog;
